import React from 'react';
import styled, { css } from 'styled-components';
import { Wrapper as LinkBoxWrapper } from '../link-box/styles';
import FiftyFifty from '../layout/containers/fifty-fifty';
import { linkOnDarkBgStyles } from '../styled/links';
import { Container } from '../styled/containers';

export const Wrapper = styled.div`
  margin-bottom: ${({ $removeMarginBottom, theme }) =>
    $removeMarginBottom ? '0' : theme.spacing.large};
  background-color: ${({ $backgroundColor, theme }) =>
    ($backgroundColor === 'white' && theme.palette.white) ||
    ($backgroundColor === 'black' && theme.palette.darkBackground) ||
    ($backgroundColor === 'grey' && theme.palette.lightBackground) ||
    theme.palette.white};
`;

export const FlexBetweenContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const ContentHalfWidth = styled((props) => <FiftyFifty {...props} />)`
  color: ${({ $backgroundColor, theme }) =>
    ($backgroundColor === 'black' && theme.palette.white) ||
    theme.palette.standardText};

  ${({ $backgroundColor }) =>
    $backgroundColor === 'black' &&
    css`
      a {
        ${linkOnDarkBgStyles}
      }
    `};

  // override current linkbox margins
  ${LinkBoxWrapper} {
    margin-top: 0px;
  }
`;

export const HeaderText = styled.h2`
  margin-top: 0;
  color: ${({ $backgroundColor, theme }) =>
    ($backgroundColor === 'black' && theme.palette.white) ||
    theme.palette.standardText};
`;

export const TextWrapper = styled.div`
  color: inherit;
`;

export const StyledContainer = styled(Container)`
  padding-top: ${({ theme }) => theme.spacing.standard};
`;
